import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface DropdownBannerProps {
  iconName: IconName;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: 16px 6px 1fr;
  grid-template-areas: 'icon . label';
  align-items: flex-start;

  background: ${(p) => p.theme.greys.shade20};
  padding: 6px 7px;
  margin: -3px 4px 4px 4px;
  border-radius: 4px;
`;

const StyledIconWrapper = styled.div`
  grid-area: icon;
`;

const StyledLabel = styled.div`
  grid-area: label;

  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const DropdownBanner: FC<PropsWithChildren<DropdownBannerProps>> = (props) => {
  const theme = useUserTheme();

  return (
    <StyledDiv>
      <StyledIconWrapper>
        <Icon name={props.iconName} color={theme.greys.shade70} />
      </StyledIconWrapper>
      <StyledLabel>{props.children}</StyledLabel>
    </StyledDiv>
  );
};
